import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class FilteredUgc extends UcoastEl {
	static htmlSelector = 'filtered-ugc'
	sliderContainer: HTMLElement
	contentToggles: NodeListOf<HTMLElement>
	detailsItems: NodeListOf<HTMLDetailsElement>
	currentHandle: string
	minHeight: number = 300
	constructor() {
		super()
		this.contentToggles = q.rl('[data-uc-filtered-ugc-toggle-item]', this)
		this.detailsItems = q.rl('[data-uc-filtered-ugc-details-item]', this)
		this.sliderContainer = q.rs('[data-uc-filtered-ugc-slider]', this)
		this.currentHandle = q.ra(this.sliderContainer, 'data-uc-filtered-ugc-slider')
	}

	override connectedCallback() {
		super.connectedCallback()
		this.open()
		this.contentToggles.forEach((toggle) => {
			toggle.addEventListener('click', (e) => {
				e.preventDefault()
				const handle = q.ra(toggle, 'data-uc-filtered-ugc-toggle-item')
				this.setCurrentHandle(handle)
				this.open()
			})
		})
	}
	setCurrentHandle(handle: string) {
		this.currentHandle = handle
	}
	open() {
		for (let i = 0; i < this.detailsItems.length; i++) {
			const contentToggle = this.contentToggles[i]
			const detailsItem = this.detailsItems[i]
			const handle = q.ra(detailsItem, 'data-uc-filtered-ugc-details-item')
			if (handle == this.currentHandle) {
				detailsItem.classList.add('active')
				contentToggle.classList.add('active')
				this.sliderContainer.style.minHeight = `${detailsItem.scrollHeight}px`
				detailsItem.style.minHeight = `${detailsItem.scrollHeight}px`
			} else {
				contentToggle.classList.remove('active')
				detailsItem.classList.remove('active')
				detailsItem.style.minHeight = `0px`
			}
		}
	}
}
